import React, { createContext, useContext, useState, useCallback } from "react";

const ReservationContext = createContext(null);

export const ReservationProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalData, setModalData] = useState(null);

  const openReservationModal = useCallback((data = null) => {
    setModalData(data);
    setIsOpen(true);
  }, []);

  const closeReservationModal = useCallback(() => {
    setIsOpen(false);
    setModalData(null);
  }, []);

  return (
    <ReservationContext.Provider
      value={{
        isReservationModalOpen: isOpen,
        openReservationModal,
        closeReservationModal,
        modalData,
      }}
    >
      {children}
    </ReservationContext.Provider>
  );
};

export const useReservation = () => {
  const context = useContext(ReservationContext);
  if (!context) {
    return {
      isReservationModalOpen: false,
      openReservationModal: () => {},
      closeReservationModal: () => {},
      modalData: null,
    };
  }
  return context;
};

export default ReservationContext;
